import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  async getAdManagerApiKeys({ commit, state }, query) {
    const headers = getTokenHeader();
    if (headers && state.selectedPrincipal?.id) {
      try {
        const response = await axios.get(
          `${env.ad_manager_api_client_url}apiKey/`,
          {
            params: {
              ...query,
              principal: state.selectedPrincipal.id
            },
            headers
          }
        );
        commit("SET_AD_MANAGER_API_KEYS", response?.data);
      } catch (e) {
        await this.dispatch("createError", e);
      }
    }
  },
  async getAdManagerConfig({ commit, state }) {
    const headers = getTokenHeader();
    if (headers) {
      const principalId = state.selectedPrincipal.id;
      const response = await axios.get(
        `${env.ad_manager_api_client_url}config/${principalId}`,
        {
          headers
        }
      );
      const organizer = response?.data ?? {};
      commit("SET_AD_MANAGER_CONFIG", organizer);
    }
  }
};
